import React, { Component } from 'react';

export default class Common extends Component {
    render() {
        return <div>common</div>;
    }
}

export const getUrlVars = () => {
    const vars = [];
    const hashes = window.location.href
        .slice(window.location.href.indexOf('?') + 1)
        .split('&');

    for (let i = 0; i < hashes.length; i++) {
        const hash = hashes[i].split('$*@=');
        vars.push(hash[1]);
    }

    return vars;
};
